import api from './api';

const aiLabApi = {
  getBriefing: (params) => api.get('/ai-lab/briefing', { params }),
  getSuggestions: () => api.get('/ai-lab/suggestions'),
};

export default aiLabApi;
